import {
    cloneElement,
    type ComponentPropsWithoutRef,
    type ElementType,
    type ForwardedRef,
    forwardRef,
    type HTMLAttributes,
    isValidElement,
    type ReactElement,
} from 'react';
import times from 'lodash/times';

export type IteratorProps<T extends ElementType = ElementType<HTMLAttributes<HTMLDivElement>>> = {
    className?: string;
    as?: T;
    count: number;
    renderItem: (index: number) => ReactElement<HTMLElement> | null;
} & ComponentPropsWithoutRef<T>;

export const Iterator = forwardRef(function Stack<T extends ElementType = 'div'>(
    props: IteratorProps<T>,
    ref: ForwardedRef<HTMLDivElement>
) {
    const { as: Component = 'div', count, renderItem, ...other } = props;

    return (
        <Component role="list" ref={ref} {...other}>
            {times(count, (idx) => {
                const element = renderItem(idx);

                return isValidElement(element) ? cloneElement(element, { role: 'listitem' }) : element;
            })}
        </Component>
    );
});
